// extracted by mini-css-extract-plugin
export default {"container":"vz-z","dimension":"wz-z","dimensionLabels":"xz-z"};